var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDataChatMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_data-chat-message"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.60056 13.7589C9.60056 13.2287 10.0303 12.799 10.5605 12.799H21.4394C21.9695 12.799 22.3993 13.2287 22.3993 13.7589C22.3993 14.289 21.9695 14.7188 21.4394 14.7188H10.5605C10.0303 14.7188 9.60056 14.289 9.60056 13.7589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5605 17.279C10.0303 17.279 9.60056 17.7088 9.60056 18.2389C9.60056 18.7691 10.0303 19.1988 10.5605 19.1988H18.8797C19.4098 19.1988 19.8396 18.7691 19.8396 18.2389C19.8396 17.7088 19.4098 17.279 18.8797 17.279H10.5605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20126 15.9986C3.20126 8.93026 8.93163 3.19989 16 3.19989C23.0684 3.19989 28.7988 8.93026 28.7988 15.9986C28.7988 23.067 23.0684 28.7974 16 28.7974C13.8855 28.7974 11.892 28.2793 10.1352 27.3709L5.23303 28.7389C4.03167 29.0748 2.92602 27.968 3.26161 26.7678L4.63016 21.8681C3.71998 20.1099 3.20126 18.1151 3.20126 15.9986ZM16 5.1197C9.99191 5.1197 5.12108 9.99054 5.12108 15.9986C5.12108 17.9191 5.62278 19.7195 6.49693 21.2866C6.62027 21.5077 6.65125 21.7686 6.58314 22.0125L5.26344 26.7373L9.99088 25.418C10.2345 25.35 10.4951 25.3809 10.7161 25.504C12.2821 26.3765 14.0814 26.8776 16 26.8776C22.0081 26.8776 26.879 22.0067 26.879 15.9986C26.879 9.99054 22.0081 5.1197 16 5.1197Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDataChatMessage);
export default __webpack_public_path__ + "static/media/ico_data-chat-message.aa02bfd5ececd4ef9646beaa68d0decd.svg";
export { ForwardRef as ReactComponent };